import React from 'react';
import { Modal, Box, Typography, Button } from '@mui/material';
import LogoutOutlinedIcon from '@mui/icons-material/LogoutOutlined';

const LogoutModal = ({ open, handleClose, handleLogout }) => {
    return (
        <Modal
            open={open}
            onClose={handleClose}
            aria-labelledby="logout-modal-title"
            aria-describedby="logout-modal-description"
            sx={{
                backdropFilter: 'blur(4px)',
                backgroundColor: 'rgba(0, 0, 0, 0.5)'
            }}
        >
            <Box
                sx={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    width: { xs: '90%', sm: '400px' },
                    background: 'linear-gradient(135deg, #ffffff 0%, #f8fbff 100%)',
                    borderRadius: '16px',
                    boxShadow: '0 20px 40px rgba(0, 0, 0, 0.15), 0 0 0 1px rgba(255, 255, 255, 0.1)',
                    overflow: 'hidden',
                    outline: 'none'
                }}
            >
                {/* Header with gradient */}
                <Box
                    sx={{
                        background: 'linear-gradient(135deg, #27485D 0%, #3B9D9D 100%)',
                        p: 3,
                        color: 'white',
                        display: 'flex',
                        alignItems: 'center',
                        gap: 2
                    }}
                >
                    <Box
                        sx={{
                            width: 48,
                            height: 48,
                            borderRadius: '12px',
                            backgroundColor: 'rgba(255, 255, 255, 0.15)',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            backdropFilter: 'blur(10px)'
                        }}
                    >
                        <LogoutOutlinedIcon sx={{ fontSize: 24 }} />
                    </Box>
                    <Box>
                        <Typography 
                            id="logout-modal-title" 
                            variant="h6" 
                            component="h2"
                            sx={{ 
                                fontWeight: 600,
                                fontSize: '1.25rem',
                                mb: 0.5
                            }}
                        >
                            Confirm Logout
                        </Typography>
                        <Typography 
                            variant="body2" 
                            sx={{ 
                                opacity: 0.9,
                                fontSize: '0.875rem'
                            }}
                        >
                            You're about to sign out
                        </Typography>
                    </Box>
                </Box>

                {/* Content */}
                <Box sx={{ p: 3 }}>
                    <Typography 
                        id="logout-modal-description" 
                        sx={{ 
                            color: '#245372',
                            fontSize: '1rem',
                            lineHeight: 1.6,
                            mb: 3,
                            textAlign: 'center'
                        }}
                    >
                        Are you sure you want to logout from your chat session?
                    </Typography>

                    {/* Action Buttons */}
                    <Box 
                        sx={{ 
                            display: 'flex', 
                            gap: 2,
                            flexDirection: { xs: 'column', sm: 'row' },
                            justifyContent: 'flex-end'
                        }}
                    >
                        <Button 
                            variant="outlined" 
                            onClick={handleClose}
                            sx={{
                                borderColor: '#e0e7ff',
                                color: '#64748b',
                                backgroundColor: '#f8fafc',
                                borderRadius: '8px',
                                px: 3,
                                py: 1,
                                fontWeight: 500,
                                textTransform: 'none',
                                minWidth: '100px',
                                '&:hover': {
                                    borderColor: '#cbd5e1',
                                    backgroundColor: '#f1f5f9',
                                    color: '#475569'
                                },
                                transition: 'all 0.2s ease-in-out'
                            }}
                        >
                            Cancel
                        </Button>
                        <Button 
                            variant="contained" 
                            onClick={handleLogout}
                            sx={{
                                background: 'linear-gradient(135deg, #27485D 0%, #3B9D9D 100%)',
                                color: 'white',
                                borderRadius: '8px',
                                px: 3,
                                py: 1,
                                fontWeight: 600,
                                textTransform: 'none',
                                minWidth: '100px',
                                boxShadow: '0 4px 12px rgba(39, 72, 93, 0.3)',
                                '&:hover': {
                                    background: 'linear-gradient(135deg, #1e3a4a 0%, #2d8080 100%)',
                                    boxShadow: '0 6px 16px rgba(39, 72, 93, 0.4)',
                                    transform: 'translateY(-1px)'
                                },
                                transition: 'all 0.2s ease-in-out'
                            }}
                        >
                            Logout
                        </Button>
                    </Box>
                </Box>
            </Box>
        </Modal>
    );
};

export default LogoutModal;